module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Ded.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame-6"
  }, [_c('p', {
    staticClass: "x1ded",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('span', {
    staticClass: "char-style-override-1"
  }, [_vm._v("T")]), _vm._v("his book is dedicated to my children: Kraig, Kyle, and Erin. I am so proud of each of you, not only for what you have accomplished with your lives but for the amazing adults you have become. Be sure to always follow your dreams and reach for the stars—and there’ll be no stopping you.")]), _vm._v(" "), _c('p', {
    staticClass: "txt-noi"
  }, [_vm._v("Love you,")]), _vm._v(" "), _c('p', {
    staticClass: "txt-noi"
  }, [_vm._v("Mom")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0f55c04d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Ded.vue
// module id = 69
// module chunks = 0